import React from 'react';
import { useIntl } from 'react-intl';
import classes from './InstallAppScreen.module.scss';
import AppleIcon from '@/icons/apple.svg';
import GoogleStoreIcon from '@/icons/play-store.svg';
import { APP_STORE_URL, PLAY_STORE_URL } from '@/utils/constants';
const InstallAppScreen = () => {
    const intl = useIntl();
    const description = intl.formatMessage({
        id: 'web.app.modalDesc',
        defaultMessage: 'We have discontinued our web interface. Please install the app to stay connected and continue receiving ride requests.'
    });
    const firstDotIndex = description.indexOf('.');
    const descriptionFirstPart = firstDotIndex === -1 ? description : description.slice(0, firstDotIndex + 1);
    const descriptionSecondPart = firstDotIndex === -1 ? '' : description.slice(firstDotIndex + 1).trim();
    const openStoreLink = (url) => {
        window.open(url, '_blank', 'noopener,noreferrer');
    };
    return (React.createElement("div", { className: classes.screen },
        React.createElement("div", { className: classes.body },
            React.createElement("div", { className: classes.title }, intl.formatMessage({ id: 'web.app.modalTitle', defaultMessage: 'Switch to our mobile app to continue driving' })),
            React.createElement("div", { className: classes.desc },
                React.createElement("div", null, descriptionFirstPart),
                React.createElement("div", null, descriptionSecondPart)),
            React.createElement("div", { className: classes.stores },
                React.createElement("button", { type: "button", className: classes.storeBtn, onClick: () => { openStoreLink(APP_STORE_URL); } },
                    React.createElement("span", { className: classes.storeBtnContent },
                        React.createElement(AppleIcon, { className: classes.storeBtnIconApple }),
                        React.createElement("span", { className: classes.storeBtnText },
                            React.createElement("span", { className: classes.storeBtnTop }, "Download on the"),
                            React.createElement("span", { className: classes.storeBtnBottom }, "App Store")))),
                React.createElement("button", { type: "button", className: classes.storeBtn, onClick: () => { openStoreLink(PLAY_STORE_URL); } },
                    React.createElement("span", { className: classes.storeBtnContent },
                        React.createElement(GoogleStoreIcon, null),
                        React.createElement("span", { className: classes.storeBtnText },
                            React.createElement("span", { className: classes.storeBtnTop }, "Get it on"),
                            React.createElement("span", { className: classes.storeBtnBottom }, "Play Store"))))))));
};
export default InstallAppScreen;
